import * as React from "react";
import styled from "styled-components";
import { DayInfos } from "../utils/dates";
import { Colors } from "@blueprintjs/core";
import { useCalendarContext } from "../CalendarContext";
import classNames from "classnames";
import { ResourceDayBlock } from "./ResourceDayBlock";

const Container = styled.div`
  position: relative;
  border-bottom: 1px solid black;
  flex: 1;
  &.today {
    background-color: ${Colors.LIGHT_GRAY5};
  }
  &.weekend {
    background-color: ${Colors.LIGHT_GRAY3};
  }
`;

export interface ResourceDayColumnProps {
  day: DayInfos;
}

export function ResourceDayColumn({ day }: ResourceDayColumnProps) {
  const { horizontalResources } = useCalendarContext();

  return (
    <Container
      className={classNames({ today: day.isToday, weekend: day.isWeekEnd })}
    >
      {horizontalResources.keys.map((key, i) => (
        <ResourceDayBlock key={i} resourceKey={key} day={day} />
      ))}
    </Container>
  );
}
